import dayjs from 'common/dayjs';

export const DATETIME_VIEW_FORMATE = 'M/D(dd) HH:mm';

export const convertToIsoFormatFromDayAndHour = (day: string, hour: string) => {
  return dayjs(`${day} ${hour}`).tz().format().toString();
};

export const convertToViewFormatFromDateTime = (dateTime: string) => {
  return dayjs(dateTime).format(DATETIME_VIEW_FORMATE);
};

export const getMaxReservationDate = () => {
  return dayjs().add(3, 'month').tz().format('YYYY-MM-DD');
};

export const getMinReservationDate = () => {
  return dayjs().tz().format('YYYY-MM-DD');
};
